import { AbstractGlobalDataCommand } from "./abstractGlobalDataCommand";

export class GlobalSettingsCommand extends AbstractGlobalDataCommand {
  get: boolean;
}